import { mockCategories } from '../../../components/Charts/Line/chartDataMocks';
import { TotalAtendimentosPorte } from '../dashboard.interfaces';

const mockSeriesPorte = {
  data1: [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10, 12, 51],
  data2: [35, 41, 62, 42, 13, 18, 29, 37, 36, 51, 32, 35, 112, 51],
  data3: [87, 57, 74, 99, 75, 38, 62, 47, 82, 56, 45, 47, 87, 67],
};

export function formattedPorteSse(data: TotalAtendimentosPorte) {
  if (!data) {
    return {
      series: [],
      categories: { categories: [] },
      total: 0,
    };
  }
  const series = [
    {
      name: 'MEI',
      // data: data.atendimentos[0].total,
      data: mockSeriesPorte.data1,
    },
    {
      name: 'ME',
      // data: data.atendimentos[1].total,
      data: mockSeriesPorte.data2,
    },
    {
      name: 'EPP',
      // data: data.atendimentos[2].total,
      data: mockSeriesPorte.data3,
    },
  ];

  const categories = {
    // categories: data.atendimentos.map((item: any) => item.sigla),
    categories: mockCategories.categories,
  };

  const total = data.total;

  return {
    series,
    categories,
    total,
  };
}
